"use client";

import type { ReactNode } from "react";
import { NextIntlClientProvider } from "next-intl";
import { DEFAULT_LOCALE, type SupportedLocale } from "./locales";
import { getMessages } from "./messages";

export function IntlProvider({
  locale = DEFAULT_LOCALE,
  children,
}: {
  locale?: SupportedLocale;
  children: ReactNode;
}) {
  return (
    <NextIntlClientProvider locale={locale} messages={getMessages(locale)}>
      {children}
    </NextIntlClientProvider>
  );
}
